import React from 'react';
import moment from 'moment-timezone';
import { Typography, List, Card } from 'antd';
import AutoSizeTitle from '../components/autoSizeTitle/AutoSizeTitle';

const { Title, Text } = Typography;

const PageRecommendations = ({ selectedEvaluation, totalResults, pageNumber }) => {
    const backgroundStyle = {
        backgroundImage: `url('/informs/pagina.png')`,
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'left top',
        backgroundSize: '100% auto',
    };

    const red = parseFloat(selectedEvaluation.evl_max_red_light);
    const yellow = parseFloat(selectedEvaluation.evl_max_yellow_light);
    const dimensions = Object.entries(totalResults.average_by_dimension || [])
        .filter(([key]) => !key.toLowerCase().includes("general"))
        .map(([, value]) => value);

    // Fortalezas: promedio > límite amarillo
    const strengths = dimensions.filter(dim => dim.average > yellow);

    // Oportunidades de mejora: promedio <= límite rojo
    const improvementOpportunities = dimensions.filter(dim => dim.average <= red);

    const midpoint = (red + yellow) / 2;

    const betweenRedAndYellow = dimensions.filter(
        dim => dim.average > red && dim.average <= yellow
    );
    
    const possibleStrengths = betweenRedAndYellow
    .filter(dim => dim.average > midpoint)
    .sort((a, b) => b.average - a.average);
    
    const possibleImprovements = betweenRedAndYellow
    .filter(dim => dim.average <= midpoint)
    .sort((a, b) => a.average - b.average);

    return (
        <div className="pdf-page internal-page">
            <div className="internal-page-content" style={backgroundStyle}>
                <AutoSizeTitle text={selectedEvaluation.evl_title} />

                <div className="internal-page-info">
                    <Card
                        style={{
                            borderRadius: '8px',
                            border: '1px solid #d9d9d9',
                            backgroundColor: '#fafafaff',
                            boxShadow: 'none',
                        }}
                        styles={{ body: { padding: '16px 24px' } }}
                    >
                        <Title level={4} style={{ color: '#339C98', marginBottom: 16 }}>
                            Recomendaciones
                        </Title>

                        {/* Fortalezas */}
                        {strengths.length > 0 && (
                            <>
                                <Title level={5} style={{ color: "#43a047", marginTop: 16 }}>✅ Fortalezas</Title>
                                <Card style={{ backgroundColor: "#e8f5e9", marginBottom: 16 }}>
                                    <ul style={{ paddingLeft: 20, marginBottom: 0, marginTop: 0 }}>
                                        {strengths.map((item, index) => (
                                            <li key={`strength-${index}`}>
                                                <Text>{item.title} – <strong>{item.average.toFixed(1)}%</strong></Text>
                                            </li>
                                        ))}
                                    </ul>
                                </Card>
                            </>
                        )}

                        {/* Oportunidades de mejora */}
                        {improvementOpportunities.length > 0 && (
                            <>
                                <Title level={5} style={{ color: "#e53935", marginTop: 16 }}>❌ Oportunidades de mejora</Title>
                                <Card style={{ backgroundColor: "#ffebee", marginBottom: 16 }}>
                                    <ul style={{ paddingLeft: 20, marginBottom: 0, marginTop: 0 }}>
                                        {improvementOpportunities.map((item, index) => (
                                            <li key={`opportunity-${index}`}>
                                                <Text>{item.title} – <strong>{item.average.toFixed(1)}%</strong></Text>
                                            </li>
                                        ))}
                                    </ul>
                                </Card>
                            </>
                        )}

                        {/* Posibles fortalezas */}
                        {possibleStrengths.length > 0 && (
                            <>
                                <Title level={5} style={{ color: "black", marginTop: 16 }}>🟡 Dimensiones que están cerca de convertirse en ajuste alto</Title>
                                <Card style={{ backgroundColor: "#ffffff", marginBottom: 16 }}>
                                    <ul style={{ paddingLeft: 20, marginBottom: 0, marginTop: 0 }}>
                                        {possibleStrengths.map((item, index) => (
                                            <li key={`possible-strength-${index}`}>
                                                <Text>{item.title} – <strong>{item.average.toFixed(1)}%</strong></Text>
                                            </li>
                                        ))}
                                    </ul>
                                </Card>
                            </>
                        )}

                        {/* Posibles oportunidades de mejora */}
                        {possibleImprovements.length > 0 && (
                            <>
                                <Title level={5} style={{ color: "black", marginTop: 16 }}>🟡 Dimensiones que estan cerca de convertirse en bajo ajuste:</Title>
                                <Card style={{ backgroundColor: "#ffffff", marginBottom: 16 }}>
                                    <ul style={{ paddingLeft: 20, marginBottom: 0, marginTop: 0 }}>
                                        {possibleImprovements.map((item, index) => (
                                            <li key={`possible-improvement-${index}`}>
                                                <Text>{item.title} – <strong>{item.average.toFixed(1)}%</strong></Text>
                                            </li>
                                        ))}
                                    </ul>
                                </Card>
                            </>
                        )}

                    </Card>
                </div>

                <div className="internal-page-number">{pageNumber}</div>
            </div>
        </div>
    );
};

export default PageRecommendations;
